import { withTranslation } from 'react-i18next';
import AppDomainInput from './AppDomainInput';

export default withTranslation()(AppDomainInput);
